<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.xsOnly" v-model="showDialog" max-width="80%"
            content-class="document-viewer">
    <v-card>
      <v-toolbar fixed flat>
        <v-row align="center">
          <v-col class="d-none d-sm-block">
            <v-toolbar-title class="text-caption" v-if="currentDoc">{{ currentDoc.name }}</v-toolbar-title>
          </v-col>
          <!-- Rotate Btns -->
          <v-col v-if="currentDoc && currentDoc.fileType !== 'application/pdf'" class="d-none d-sm-block text-center" align-self="center">
            <v-tooltip bottom>
              <template v-slot:activator="{on, attr}">
                <v-icon
                    @click="rotateClockwise"
                    class="mr-3 greyBold--text"
                    v-bind="attr"
                    v-on="on"
                >
                  rotate_right
                </v-icon>
              </template>
              <span>{{ $t('components:document-viewer.rotate-right') }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{on, attr}">
                <v-icon
                    @click="rotateAntiClockwise"
                    class="greyBold--text"
                    v-bind="attr"
                    v-on="on"
                >
                  rotate_left
                </v-icon>
              </template>
              <span>{{ $t('components:document-viewer.rotate-left') }}</span>
            </v-tooltip>
          </v-col>
          <v-col v-else></v-col>

          <!-- Close Button -->
          <v-col class="text-end">
            <v-icon
                @click="closeDialog()"
                class="greyBold--text"
            >
              close
            </v-icon>
          </v-col>
        </v-row>
      </v-toolbar>
      <v-card-text>
        <!-- Document switcher -->
        <div v-if="src.length > 1" class="doc-switcher">
          <v-tooltip bottom>
            <template v-slot:activator="{on, attr}">
              <v-icon
                  x-large
                  color="primary"
                  @click="prevDoc"
                  class="prev-doc"
                  v-bind="attr"
                  v-on="on"
              >
                navigate_before
              </v-icon>
            </template>
            <span>{{ $t('components:document-viewer.prev-doc') }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{on, attr}">
              <v-icon
                  x-large
                  color="primary"
                  @click="nextDoc"
                  class="next-doc"
                  v-bind="attr"
                  v-on="on"
              >
                navigate_next
              </v-icon>
            </template>
            <span>{{ $t('components:document-viewer.next-doc') }}</span>
          </v-tooltip>
        </div>

        <div v-if="currentDoc && currentDoc.fileType === 'application/pdf'" class="container px-16 py-5">
          <p>{{ $t('components:document-viewer.pdf-other-tab') }}</p>
          <BaseButton
              :btn-text="$t('components:document-viewer.open-pdf')"
              @clickedButton="openPDFInNewTab"
              color="primary"
          />
        </div>

        <img
            v-else-if="currentDoc"
            id="image"
            :src="docSource"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DocumentationService from '@/modules/core/services/documentation-service';
import BaseButton from "@/modules/core/components/Base/BaseButton";

export default {
  name: 'DocumentViewer',
  components: {BaseButton},
  props: {
    qrCodeForPublic: String,
    offline: Boolean,
    public: Boolean
  },
  data() {
    return {
      showDialog: false,
      src: [], // all documents from table
      numPages: 0, // number of pages of document
      page: 1, // current page to display
      rotate: 0, // val for rotating document
      currentDoc: undefined, // document that is currently displayed
      docSource: '', //source of the current documentation
      relationId: null, // UserId or FacilityId
      documentType: '' // Current DocumentType(USER, STEP, FACILITY)
    }
  },
  methods: {
    initViewer(docus, docToView, relationId) {
      this.src = docus;
      this.relationId = typeof relationId !== 'undefined' && relationId ? relationId : null;
      for (var i = 0; i < this.src.length; i++) {
        if (this.src[i].fileName === docToView) {
          this.currentDoc = this.src[i];
        }
      }
    },
    initViewerById(docus, docToView, relationId, documentType) {
      this.src = docus;
      this.documentType = documentType ? documentType : '';
      this.relationId = typeof relationId !== 'undefined' && relationId ? relationId : null;
      for (var i = 0; i < this.src.length; i++) {
        if (this.src[i].id === docToView) {
          this.currentDoc = this.src[i];
        }
      }
    },
    rotateClockwise() {
      this.rotate += 90;
      if (this.currentDoc.fileType != 'application/pdf') {
        var img = document.getElementById('image');
        this.rotate = this.rotate % 360;
        img.className = "rotate" + this.rotate;
      }
    },
    rotateAntiClockwise() {
      this.rotate -= 90;
      if (this.currentDoc.fileType != 'application/pdf') {
        var img = document.getElementById('image');
        this.rotate = this.rotate % 360;
        img.className = "rotate" + this.rotate;
      }
    },
    getArrayPosition() {
      for (var i = 0; i < this.src.length; i++) {
        if (this.src[i].id === this.currentDoc.id) {
          return i;
        }
      }
    },
    prevDoc() {
      this.rotate = 0;
      if (this.src[this.getArrayPosition() - 1]) {
        this.currentDoc = this.src[this.getArrayPosition() - 1];
      } else {
        this.currentDoc = this.src[this.src.length - 1];
      }
    },
    nextDoc() {
      this.rotate = 0;
      this.page = 1;
      if (this.src[this.getArrayPosition() + 1]) {
        this.currentDoc = this.src[this.getArrayPosition() + 1];
      } else {
        this.currentDoc = this.src[0];
      }
    },

    // converts a base64 string to a blob
    b64ToBlob (base64Data, contentType) {
      const byteCharacters = atob(base64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      return new Blob(byteArrays, { type: contentType})
    },
    resetViewer() {
      this.src = [];
      this.currentDoc = null;
      this.docSource = null;
    },
    closeDialog() {
      this.showDialog = false
      this.resetViewer();
    },
    openPDFInNewTab() {
      const base64Result = this.docSource.split('base64,')[1];

      // convert the base64 to a blob
      const blob = this.b64ToBlob(base64Result, this.currentDoc.fileType);
      // create url for the blob
      const blobUrl = URL.createObjectURL(blob);
      // open the blob in a new tab
      window.open(blobUrl, '_blank');
    },
    defaultLoader() {
      DocumentationService.getFileAsDataUrl(
          this.currentDoc.id,
          this.currentDoc.fileType,
          (result) => {
            this.docSource = result;

            // if the document is of type pdf
            // open the pdf in another tab so he can view it
            if (this.currentDoc.fileType === 'application/pdf') {
              this.openPDFInNewTab();
            } else {
              this.showDialog = true;
            }
          }
      )
    },
    loadDocByTypeRelation() {
      DocumentationService.getDocByTypeAndId(
          this.currentDoc.id,
          this.currentDoc.fileType,
          this.documentType,
          this.relationId,
          (result) => {
            this.docSource = result;

            // if the document is of type pdf
            // open the pdf in another tab so he can view it
            if (this.currentDoc.fileType === 'application/pdf') {
              this.openPDFInNewTab();
            } else {
              this.showDialog = true;
            }
          }
      )
    },
    loadDocByTypeRelationForPublic() {
      DocumentationService.getDocByTypeAndIdForPublic(
          this.currentDoc.id,
          this.currentDoc.fileType,
          this.documentType,
          this.relationId,
          this.$route.params.code,
          (result) => {
            this.docSource = result;

            // if the document is of type pdf
            // open the pdf in another tab so he can view it
            if (this.currentDoc.fileType === 'application/pdf') {
              this.openPDFInNewTab();
            } else {
              this.showDialog = true;
            }
          }
      )
    }
  },
  watch: {
    currentDoc() {
      if (!this.currentDoc) {
        return;
      }

      if (!this.offline && !this.public) {
        if (this.documentType.length === 0 || !this.relationId) {
          this.defaultLoader();
        } else {
          this.loadDocByTypeRelation();
        }
      } else if (!this.offline && this.public) {
        this.loadDocByTypeRelationForPublic();
      } else {
        this.docSource = this.currentDoc.src;

        if (this.currentDoc.fileType === 'application/pdf') {
          this.openPDFInNewTab();
        } else {
          this.showDialog = true;
        }
      }
    }
  }
}
</script>
<style src="@/modules/core/components/DocumentViewer/DocumentViewer.scss" lang="scss"/>
